var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon4, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPink2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.66 96.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-width:0px;}.cls-1,.cls-19{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-19{stroke:#faef75;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-8);}.cls-7{fill:url(#linear-gradient-9);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:#7aabbb;}.cls-12{fill:#9ab1ce;}.cls-13{fill:#121413;}.cls-14{fill:#ded266;}.cls-15{fill:#cfb800;}.cls-16{fill:#ff74a8;}.cls-17{fill:#fff;}.cls-18{fill:#faef75;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.11,
    y1: 8.88,
    x2: 17.02,
    y2: 12.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd9291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e7b0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#efc7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f5d7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f8e1df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fae4e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.87,
    y1: 8.76,
    x2: 43.79,
    y2: 11.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3881.81,
    y1: 3272.05,
    x2: 3888.4,
    y2: 3272.05,
    gradientTransform: "translate(4111.97 2998.71) rotate(-103.89) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3886.42,
    y1: 3272.12,
    x2: 3887.98,
    y2: 3272.16,
    gradientTransform: "translate(4111.97 2998.71) rotate(-103.89) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2724.88,
    y1: -1406.06,
    x2: 2731.47,
    y2: -1406.06,
    gradientTransform: "translate(765.73 2998.71) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2729.49,
    y1: -1405.99,
    x2: 2731.05,
    y2: -1405.95,
    gradientTransform: "translate(765.73 2998.71) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 30.52,
    y1: 24.25,
    x2: 30.52,
    y2: 33.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 30.65,
    y1: 8.79,
    x2: 30.65,
    y2: 24.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 30.34,
    y1: 11.3,
    x2: 31.28,
    y2: 41.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#bd8e55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d4aa7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e5bf97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f0cca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f4d1af"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.46,14.27c-1.23.83-2.42.18-2.69,0-.49-.33-.24-3.39-.24-4.23,0-.15.06-.28.17-.38.18-.17.52-.39,1.04-.4.84-.02,1.89.92,1.89.92l-.17,4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m42.39,14.27c1.23.83,2.42.18,2.69,0,.49-.33.24-3.39.24-4.23,0-.15-.06-.28-.17-.38-.18-.17-.52-.39-1.04-.4-.84-.02-1.89.92-1.89.92l.17,4.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m14.66,87.18l5.65-.2.96-15.06c.13-2.05-1.54-3.76-3.59-3.69h0c-1.9.07-3.39,1.64-3.35,3.54l.32,15.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m22.14,60.97l-6.84,8.19c-1.35,1.62-1.12,4.03.52,5.36h0c1.51,1.22,3.7,1.1,5.06-.28l7.54-7.63c1.57-1.59,1.43-4.19-.31-5.59l-.7-.57c-1.6-1.3-3.95-1.07-5.28.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m22.07,57.29h17.31v4.05c0,2.36-1.92,4.28-4.28,4.28h-8.74c-2.36,0-4.28-1.92-4.28-4.28v-4.05h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.14 14.82 4.86 13.68 5.27 12.97 4.86 10.13 4.57 8.95 3.33 9.26 3.42 9.79 2.43 9.94 1.6 10.13 .83 10.39 .87 10.56 .79 10.25 0 10.38 .08 11.03 0 11.63 .85 14.17 1.7 14.66 2.08 16.35 5.31 15.55 5.14 14.82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.28,10.51l-.97-.09s-.02,0-.03,0l-.52.45s-.04.01-.05,0l-.3-.22s-.03-.01-.04,0l-.34.14-.34.14s-.01,0-.02,0l-.41-.02s-.02,0-.03,0l-.74.59.81-.48s.02,0,.02,0l.37.04s.02,0,.03,0l.27-.17s0,0,0,0l.3-.1s.02,0,.03,0l.36.22s.03,0,.05,0l.55-.48s.02,0,.03,0l.96-.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m8.04,30.87h0c1.37-.5,2.08-2.02,1.58-3.39l-4.16-12.85-3.84,1.21,2.94,13.13c.35,1.55,1.99,2.45,3.49,1.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m4.75,27.3h0c.55-1.34,2.03-2.03,3.41-1.59l13.56,4.28c2.07.66,3.14,2.94,2.32,4.96h0c-.81,1.96-3.09,2.85-5.01,1.95l-12.88-6.02c-1.34-.63-1.96-2.2-1.39-3.58Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "53.52 14.82 53.8 13.68 53.39 12.97 53.8 10.13 54.09 8.95 55.33 9.26 55.24 9.79 56.22 9.94 57.06 10.13 57.83 10.39 57.79 10.56 57.86 10.25 58.66 10.38 58.58 11.03 58.65 11.63 57.8 14.17 56.96 14.66 56.58 16.35 53.34 15.55 53.52 14.82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m54.38,10.51l.97-.09s.02,0,.03,0l.52.45s.04.01.05,0l.3-.22s.03-.01.04,0l.34.14.34.14s.01,0,.02,0l.41-.02s.02,0,.03,0l.74.59-.81-.48s-.02,0-.02,0l-.37.04s-.02,0-.03,0l-.27-.17s0,0,0,0l-.3-.1s-.02,0-.03,0l-.36.22s-.03,0-.05,0l-.55-.48s-.02,0-.03,0l-.96-.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m50.61,30.87h0c-1.37-.5-2.08-2.02-1.58-3.39l4.16-12.85,3.84,1.21-2.94,13.13c-.35,1.55-1.99,2.45-3.49,1.9Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m53.91,27.57h0c-.55-1.34-2.03-2.03-3.41-1.59l-13.56,4.28c-2.07.66-3.14,2.94-2.32,4.96h0c.81,1.96,3.09,2.85,5.01,1.95l12.88-6.02c1.34-.63,1.96-2.2,1.39-3.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.8,85.61c.94-.03,1.72.71,1.72,1.65.01,1.29.04,3.01.12,4.1.12,1.74.15,4.33.15,4.33,0,0-9.02,1.09-10.96.87,0,0-.03-3.57,3.52-3.98,3.55-.42,4.23-.25,4.23-.25l-.39-4.93c-.07-.94.65-1.76,1.6-1.8h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m19.77,92.58c-.98.79-1.43,1.88-1.63,2.66-.06.23-.1.44-.12.6,1.1-.12,1.83-.21,1.83-.21,0,0,0-.2,0-.52-.01-.58-.03-1.56-.08-2.53Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m17.52,93.13l-.16-4.41-1.05.04.28,3.57s-.68-.17-4.23.25c-.33.04-.63.11-.91.19l.72.81c2.2-1.15,5.34-.45,5.34-.45Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m18.12,95.3c-2.62.18-7.14.47-7.14.47-.09-1.21-.42-1.9-.78-2.28-1.35,1.19-1.34,3.07-1.34,3.07,1.38.16,6.39-.36,9.13-.66,1.1-.12,1.83-.21,1.83-.21,0,0,0-.2,0-.52-.26.03-.89.07-1.7.13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 13.59,
    y: 85.39,
    width: 7.01,
    height: 2.99
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m46.94,86.79l-5.65-.2-.96-15.06c-.13-2.05,1.54-3.76,3.59-3.69h0c1.9.07,3.39,1.64,3.35,3.54l-.32,15.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m39.46,60.58l6.84,8.19c1.35,1.62,1.12,4.03-.52,5.36h0c-1.51,1.22-3.7,1.1-5.06-.28l-7.54-7.63c-1.57-1.59-1.43-4.19.31-5.59l.7-.57c1.6-1.3,3.95-1.07,5.28.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.8,85.21c-.94-.03-1.72.71-1.72,1.65-.01,1.29-.04,3.01-.12,4.1-.12,1.74-.15,4.33-.15,4.33,0,0,9.02,1.09,10.96.87,0,0,.03-3.57-3.52-3.98-3.55-.42-4.23-.25-4.23-.25l.39-4.93c.07-.94-.65-1.76-1.6-1.8h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m41.83,92.19c.98.79,1.43,1.88,1.63,2.66.06.23.1.44.12.6-1.1-.12-1.83-.21-1.83-.21,0,0,0-.2,0-.52.01-.58.03-1.56.08-2.53Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m44.08,92.73l.16-4.41,1.05.04-.28,3.57s.68-.17,4.23.25c.33.04.63.11.91.19l-.72.81c-2.2-1.15-5.34-.45-5.34-.45Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m43.47,94.9c2.62.18,7.14.47,7.14.47.09-1.21.42-1.9.78-2.28,1.35,1.19,1.34,3.07,1.34,3.07-1.38.16-6.39-.36-9.13-.66-1.1-.12-1.83-.21-1.83-.21,0,0,0-.2,0-.52.26.03.89.07,1.7.13Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 41,
    y: 84.99,
    width: 7.01,
    height: 2.99,
    transform: "translate(89.01 172.97) rotate(-180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "33.37 31.01 27.67 31.01 28.46 23.26 32.58 23.26 33.37 31.01"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m43.21,32.26c.1-1-.33-2.04-1.21-2.53-.29-.16-.6-.27-.94-.31l-7.93-.96s-.19,1.71-2.6,1.71-2.6-1.71-2.6-1.71l-7.93.96c-.34.04-.66.15-.94.31-.88.49-1.32,1.53-1.21,2.53l3.09,28.41h19.34l2.95-28.42Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m30.65,6.37h-10.83c-.73,0-1.33.59-1.33,1.33v8.25c0,2.64,1.48,5.07,3.83,6.28l5.08,2.63c2.04,1.05,4.45,1.05,6.49,0l5.08-2.63c2.35-1.21,3.83-3.64,3.83-6.28V7.7c0-.73-.59-1.33-1.33-1.33h-10.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m22.49,29.08s3.5,10.17-2.84,19.86l.23,2.06s11.48-8.54,6.4-22.33c0,0-3.31.16-3.79.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m39.07,29.08s-3.93,10.22,2.4,19.92l-.21,2.02s-11.06-8.55-5.98-22.34c0,0,3.31.16,3.79.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.73,62.24c-1.38.03-1.38,1.71-1.38,1.71v.12s2.77,0,2.77,0v-.18s0-1.68-1.39-1.66Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m29.76,34.28h1.92c4.87,0,8.82,3.95,8.82,8.82v8.97c0,2.51-2.04,4.55-4.55,4.55h-10.45c-2.51,0-4.55-2.04-4.55-4.55v-8.97c0-4.87,3.95-8.82,8.82-8.82Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m23.61,47.67h15.01v5.85c0,.4-.32.72-.72.72h-13.57c-.4,0-.72-.32-.72-.72v-5.85h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "23.61 46.49 38.62 46.49 39.06 48.02 23.08 48.02 23.61 46.49"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m27.74.37l-4.38.64c-1.79.38-3.35,1.45-4.36,2.98l-.93,1.42c-.74,1.12-1.14,2.44-1.15,3.78l-.07,11.41c0,.51.05,1.03.16,1.53l.78,3.6c.62,2.84,2.94,5,5.83,5.41l5.79.82c.65.09,1.31.09,1.95,0l5.59-.79c2.98-.42,5.35-2.71,5.88-5.67l.91-5.13c.06-.36.1-.72.11-1.09l.16-11.39c.02-.93,0-1.26-.24-2.12l-.25-.6c-.96-2.41-3.18-4.08-5.76-4.35L31.5.01c-.72-.07-3.06.2-3.77.35Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m28.17,35.89s-.04-3.52,2.13-3.55,2.38,3.24,2.38,3.24l-4.51.31Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink2);
export default __webpack_public_path__ + "static/media/pink_2.db1a590e41e8ffefa8de2340054b2e73.svg";
export { ForwardRef as ReactComponent };